import { StatusBadge } from '@/components/projects/StatusBadge'
import { getTestPlanStatusLabel } from '@/types'

export function TestPlanStatusBadge({ status }: { status: string }) {
  return <StatusBadge status={status} label={getTestPlanStatusLabel(status)} testIdPrefix="test-plan" />
}
